module.exports = __webpack_public_path__ + "files/9ac27888fb8a81f276b717e66474584e.png";